import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import MainTitle from "../../../components/ui/MainTitle";
import SubmitButton from "../../../components/form/SubmitButton";
import { useUpdateResource } from "../../../hooks/useUpdateResource";
import { useTranslation } from "react-i18next";
import LoadingButton from "../../../components/form/LoadingButton";
import LoyaltyOfferForm, { LoyaltyOfferFormData } from "../../../components/admin/loyaltyOffers/LoyaltyOfferForm";

export default function AdminAddLoyaltyOfferPage() {
  const navigate = useNavigate();

  const { register, handleSubmit, formState: { errors } ,watch} = useForm<LoyaltyOfferFormData>({
  });

   const { t } = useTranslation();
  const { loading, updateResource } = useUpdateResource();

  const onSubmit = (data: LoyaltyOfferFormData) => {
    let dataToSend :any={amountRequired:+data.amountRequired,bonusAmount:+data.bonusAmount};
    if(data.startDate){
        dataToSend.startDate = new Date( data.startDate).toISOString();
    }
     if(data.endDate){
        dataToSend.endDate = new Date( data.endDate).toISOString();
    }
    console.log(dataToSend)
    updateResource(`loyalty-offer`, 
        {...dataToSend},
        "admin",{
            method: "POST",
            successMessage: t("createdSuccess"),
            invalidateQueries: ["loyalty-offers-by-admin"],
            navigateAfter: () => navigate("/admin/loyalty-offers"),
          });
  };

  return (
    <div className="p-6 container">
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4 w-full">
        <MainTitle title="add_new_loyalty_offer" />
        <LoyaltyOfferForm register={register} errors={errors} watch={watch}/>
        {
        loading?
        <LoadingButton height={64}/> 
        :
        <SubmitButton height={64} label="create" />
        }
      </form>
    </div>
  );
}
